module.exports = __webpack_public_path__ + "static/media/bg4.61a25aba.png";